import { render, staticRenderFns } from "./BtnInserirResponsavel.vue?vue&type=template&id=1d347e39"
import script from "./BtnInserirResponsavel.vue?vue&type=script&lang=js"
export * from "./BtnInserirResponsavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports